<template>
  <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 101.64 101.64" xml:space="preserve">
    <path :style="`fill: ${setFillColors.inner}`" d="M48.68,21.56c-.51-.32-1.18-.16-1.5.35l-10.17,16.27-5.57-5.57c-.43-.42-1.11-.42-1.54,0-.42.43-.42,1.12,0,1.54l6.54,6.54c.21.21.48.32.77.32h.12c.33-.04.62-.23.8-.51l10.89-17.43c.32-.51.16-1.18-.35-1.5"/>
    <path :style="`fill: ${setFillColors.inner}`" d="M73.16,57.35c-.81,0-1.56.22-2.21.61-.24-2.18-2.09-3.88-4.33-3.88-.9,0-1.73.27-2.43.74-.6-1.7-2.21-2.92-4.11-2.92-.79,0-1.54.22-2.18.59v-12.38c0-2.11-1.38-3.89-3.27-4.4v-16.49c0-1.8-1.47-3.27-3.27-3.27h-23.97c-1.8,0-3.27,1.47-3.27,3.27v23.97c0,1.8,1.47,3.27,3.27,3.27h21.79v15.93l-3.6-3.55c-.81-.8-1.88-1.25-3.02-1.25s-2.21.44-3.02,1.25c-.81.81-1.25,1.88-1.25,3.02,0,1.03.37,2.03,1.05,2.81l2.26,2.59c2.21,2.52,3.86,5.43,4.78,8.43.9,2.92,2.67,5.42,5.12,7.23,2.46,1.81,5.37,2.77,8.42,2.77h1.89c8.15,0,14.84-6.38,15.24-14.53l.45-9.4v-.05c0-2.4-1.95-4.36-4.36-4.36M27.4,44.28c-.6,0-1.09-.49-1.09-1.09v-23.97c0-.6.49-1.09,1.09-1.09h23.97c.6,0,1.09.49,1.09,1.09v16.5c-1.88.49-3.27,2.19-3.27,4.22v4.34h-21.79ZM74.89,71.05c-.34,6.99-6.08,12.46-13.06,12.46h-1.89c-2.58,0-5.05-.81-7.13-2.35-2.08-1.53-3.57-3.65-4.33-6.12-1-3.29-2.81-6.48-5.22-9.22l-2.26-2.59c-.33-.38-.52-.87-.52-1.38,0-.56.22-1.09.62-1.48.39-.39.92-.61,1.48-.61s1.08.22,1.48.62l5.46,5.38c.31.31.78.4,1.19.23.4-.17.67-.57.67-1.01v-25.06c0-1.2.98-2.18,2.18-2.18h.12c1.14.06,2.06,1.12,2.06,2.36v18.33c0,.6.49,1.09,1.09,1.09s1.09-.49,1.09-1.09v-2.18c0-1.2.98-2.18,2.18-2.18s2.18.98,2.18,2.18v3.27c0,.6.49,1.09,1.09,1.09s1.09-.49,1.09-1.09v-1.09c0-1.2.98-2.18,2.18-2.18s2.18.98,2.18,2.18v3.27c0,.6.49,1.09,1.09,1.09s1.09-.49,1.09-1.09c0-1.2.98-2.18,2.18-2.18s2.17.96,2.18,2.16l-.45,9.37Z"/>
    <path :style="`fill: ${setFillColors.outer}`" d="M50.82,101.64C22.81,101.64,0,78.84,0,50.82S22.81,0,50.82,0s50.82,22.81,50.82,50.82-22.81,50.82-50.82,50.82M50.82,3.07C24.5,3.07,3.07,24.5,3.07,50.82s21.41,47.75,47.75,47.75,47.75-21.43,47.75-47.75S77.14,3.07,50.82,3.07"/>
</svg>
</template>

<script>
export default {
  name: 'IconStep1',
  props: ['colorState'],
  computed: {
    setFillColors() {
      if (this.colorState === 'focus') {
        return {
          inner: '#E3342C',
          outer: '#045893',
        }
      } else if (this.colorState === 'complete') {
        return {
          inner: '#00BAF2',
          outer: '#00BAF2',
        }
      } else if (this.colorState === 'inactive') {
        return {
          inner: '#b3b3b3',
          outer: '#b3b3b3',
        }
      }
    }
  }
}
</script>
